import http from "@/http/axios";
import { appModule } from "@/store/modules/app";

function has_value(item){
    return (item===null)
        ? false
        : (item===undefined)
        ? false
        : (item==="")
            ? false
            : true;
}

export async function getAsusDeviceList() {
    const result = await http.get("/asus/data");
    if(result){
        if(result.data.status === "Success"){
            return result.data.data;
        }
    }
    appModule.sendErrorNotice("取得手錶列表失敗");
}

export async function getAsusBpdataBydeviceId(device_id, page, limit, start, end) {
    let url = "/asus/data/"+device_id+"/bp";
    if(has_value(start) && has_value(end)) url = url + `?start=${start}&end=${end}`;
    else {
        appModule.sendErrorNotice("取得手錶資料失敗");
        return;
    }
    if(has_value(page)) url = url + `&page=${page}`;
    if(has_value(limit)) url = url + `&limit=${limit}`;
    const result = await http.get(url);
    if(result){
        if(result.data.status === "Success"){
            return result.data.data.ppg;
        }
    }
    appModule.sendErrorNotice("取得手錶資料失敗");
}

export async function getAsusSpodataBydeviceId(device_id, page, limit, start, end){
    let url = "/asus/data/"+device_id+"/spo";
    if(has_value(start) && has_value(end)) url = url + `?start=${start}&end=${end}`;
    else {
        appModule.sendErrorNotice("取得手錶資料失敗");
        return;
    }
    if(has_value(page)) url = url + `&page=${page}`;
    if(has_value(limit)) url = url + `&limit=${limit}`;
    const result = await http.get(url);
    if(result){
        if(result.data.status === "Success"){
            return result.data.data.spo;
        }
    }
    appModule.sendErrorNotice("取得手錶資料失敗");
}

export async function getAsusStepdataBydeviceId(device_id, page, limit, start, end){
    let url = "/asus/data/"+device_id+"/step";
    if(has_value(start) && has_value(end)) url = url + `?start=${start}&end=${end}`;
    else {
        appModule.sendErrorNotice("取得手錶資料失敗");
        return;
    }
    if(has_value(page)) url = url + `&page=${page}`;
    if(has_value(limit)) url = url + `&limit=${limit}`;
    const result = await http.get(url);
    if(result){
        if(result.data.status === "Success"){
            return result.data.data.step;
        }
    }
    appModule.sendErrorNotice("取得手錶資料失敗");
}

export async function getAsusSleepdataBydeviceId(device_id, page, limit, start, end){
    let url = "/asus/data/"+device_id+"/sleep";
    if(has_value(start) && has_value(end)) url = url + `?start=${start}&end=${end}`;
    else {
        appModule.sendErrorNotice("取得手錶資料失敗");
        return;
    }
    if(has_value(page)) url = url + `&page=${page}`;
    if(has_value(limit)) url = url + `&limit=${limit}`;
    const result = await http.get(url);
    if(result){
        if(result.data.status === "Success"){
            return result.data.data.sleep;
        }
    }
    appModule.sendErrorNotice("取得手錶資料失敗");
}

export async function getAsusAlldataBydeviceId(device_id, start, end){
    const result = await http.get(`/asus/data/${device_id}/all?start=${start}&end=${end}`);
    if(result){
        if(result.data.status === "Success"){
            return result.data.data;
        }
    }
    appModule.sendErrorNotice("取得手錶資料失敗");
}

export async function addNewAsusDevice(device_id, device_name){
    const params = {
        device_id:device_id,
    };
    if(has_value(device_name)) params['device_name'] = device_name;
    const result = await http.post("/asus/data/", params);
    if (result) {
        if (result.data.status === "Success") {
        appModule.sendSuccessNotice("新增成功");
        } else {
        appModule.sendErrorNotice("新增失敗");
        }
    }
    return;
}

export async function modifyAsusDevice(device_id, device_name, start_time, end_time, iid) {
    const params = {};
    if(has_value(device_name)) params['device_name'] = device_name;
    if(has_value(start_time)) params['start_time'] = start_time;
    if(has_value(end_time)) params['end_time'] = end_time;
    if(has_value(iid)) params['iid'] = iid;
    const result = await http.post(`/asus/data/${device_id}`, params);
    if (result) {
      if (result.data.status === "Success") {
        appModule.sendSuccessNotice("修改成功");
      } else {
        appModule.sendErrorNotice("修改失敗");
      }
    }
    return;
  }